import { useState } from 'react'
import { Link } from 'react-router-dom'

import ContactSupportPopup from '../../components/ContactSupportPopup'
import ReilmLogo from '../../components/ReilmLogo'

// Spec §2.9 T5: Home (and every other page) carries the Home line; Pricing draws its own.
const DESCRIPTIONS = {
  home: (
    <>
      Real Estate Deal Analysis for Investors <br className="hidden md:block" />
      and Wholesalers
    </>
  ),
  pricing: (
    <>
      Property Underwriting &amp; Deal Analysis <br className="hidden md:block" />
      for Real Estate Investors
    </>
  ),
}

// D14: the 360 frame draws the links at 14 although the canvas says 16; mobile follows the frame.
const LINK = 'text-[14px] md:text-[16px] leading-6 text-brand-dark hover:text-brand-primary transition-colors'
const HEAD = 'text-[20px] leading-8 font-bold text-brand-dark'

// Figma 29.09 `footer_2` / `footer_3` (1440 x 300) and `footer` (360 x 429).
const Footer = ({ variant = 'home' }) => {
  const [supportOpen, setSupportOpen] = useState(false)
  return (
    <footer className="bg-brand-band">
      <ContactSupportPopup open={supportOpen} onClose={() => setSupportOpen(false)} />
      <div
        id="company"
        className="max-w-canvas mx-auto px-5 md:px-6 canvas:px-0 pt-12 md:pt-[50px] flex flex-col md:flex-row md:justify-between"
      >
        <div className="flex">
          <div className="w-[172px] md:w-[206px]">
            <p className={HEAD}>Product</p>
            <div className="mt-4 md:mt-3 flex flex-col gap-2">
              <Link to="/pricing" className={LINK}>
                Pricing
              </Link>
            </div>
          </div>
          <div>
            <p className={HEAD}>Legal</p>
            <div className="mt-4 md:mt-3 flex flex-col gap-2">
              <Link to="/terms" className={LINK}>
                Terms
              </Link>
              <Link to="/privacy" className={LINK}>
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-9 md:mt-1 md:w-[283px]">
          <ReilmLogo className="w-[131px] h-[28px]" />
          <p className="mt-[10px] md:mt-2 text-[14px] leading-5 text-brand-dark">{DESCRIPTIONS[variant]}</p>

          <div className="mt-4 flex items-center gap-6 md:gap-[30px]">
            {/* Tertiary button (canvas). Hover is not drawn (M8); it borrows the navbar Login hover. */}
            <button
              type="button"
              onClick={() => setSupportOpen(true)}
              className="h-10 px-[23px] rounded-full border border-[#B7C7B2] text-brand-dark text-[14px] font-semibold whitespace-nowrap hover:text-brand-primary hover:border-brand-primary transition-colors"
            >
              Contact Support
            </button>
            <div className="text-[14px] leading-6 text-brand-dark">
              <p>Monday–Friday</p>
              <p>9AM–5PM EST</p>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-[34px] md:mt-[38px] border-t border-[#E3E9E0]">
        <div className="max-w-canvas mx-auto px-5 md:px-6 canvas:px-0 pt-[23px] pb-[21px] md:pb-6">
          <p className="text-[12px] leading-5 text-brand-secondary">©2026 Arvance, LLC | All rights reserved</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
